import { NARRATOR_OPTIONS, normalizeNarrator, SettingKey } from "@serophin/nottldr-shared";
import { Headphones } from "lucide-preact";
import { NarratorOptionButton } from "./NarratorOptionButton";
import { SettingsCard } from "./SettingsCard";
import { SpeedSetting } from "./SpeedSetting";
import { useNarratorSample } from "./useNarratorSample";
import type { SettingsState } from "./useSettingsState";

export const NarratorSettings = ({ settings }: { settings: SettingsState }) => {
  const narrator = normalizeNarrator(settings.get(SettingKey.NARRATOR));
  const sample = useNarratorSample();

  return (
    <SettingsCard icon={Headphones} title="Audio Narrator">
      <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">Choose your preferred narrator voice for article audio</p>
      <div class="space-y-3">
        {NARRATOR_OPTIONS.map((option) => (
          <NarratorOptionButton
            key={option.value}
            flag={option.flag}
            title={option.title}
            isSelected={narrator === option.value}
            isPlaying={sample.playing === option.value}
            isLoading={sample.loading === option.value}
            onClick={() => settings.change([{ key: SettingKey.NARRATOR, value: option.value }])}
            onPlaySample={() => sample.toggle(option.value)}
          />
        ))}
      </div>
      <SpeedSetting settings={settings} />
    </SettingsCard>
  );
};
